import { Model, belongsTo, hasMany } from 'miragejs';

export default Model.extend({
  companyRoles: hasMany(),
  deliveriesSubscription: belongsTo('subscription', { inverse: null }),
  googleApp: belongsTo(),
  iftttIntegration: belongsTo(),
  locations: hasMany(),
  oktaIntegration: belongsTo(),
  oneLogin: belongsTo(),
  salesforceIntegration: belongsTo(),
  saml: belongsTo(),
  scimIntegration: belongsTo(),
  slackIntegration: belongsTo(),
  subscription: belongsTo('subscription', { inverse: null }),
  zapierIntegration: belongsTo(),
  vfdCompanyConfiguration: belongsTo('vfd-company-configuration'),
});
